<app-content>
  <app-breadcrumbs>
    <li>
      Wnioski zatwierdzone
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Wnioski zatwierdzone
    </h2>
    <ng-container *ngIf='!loading()'>
      <div class='row'>
        <div class='col-md-6'>
          <div class='form-group'>
            <label for='name'>Szukaj wniosek</label>
            <input autocomplete='off' [(ngModel)]='filterValue' id='name' type='text'
                   placeholder='Wpisz nazwę usługi lub datę' />
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-md-8'>
          <ul class='item-list'>
            <li style='max-width: fit-content'
                *ngFor='let item of applications() | filterData: filterValue : false : "tag"'>
              <div>
                <a
                  [routerLink]='"/wnioski-zatwierdzone" + item.application?.service?.url + "/" + item.application?.uuid'>
                  {{ item?.application?.service?.name || 'Nieznana usługa' }}.
                </a>&nbsp;
              </div>
              <div>
                <small>
                  Data zatwierdzenia: <strong>{{ item?.application?.approvedAt | date: 'dd.MM.yyyy HH:mm' }}</strong>
                </small>
                <br>
                <small>
                  Podpisano:
                  <strong>{{ item.application?.signedDocument?.id ? 'Tak' : 'Nie'}}</strong>
                </small>
              </div>
            </li>
          </ul>
          <app-alert
            *ngIf='!(applications() | filterData: filterValue : false : "tag").length'
            content='Brak wynników'
            [closable]='false'>
          </app-alert>
        </div>
      </div>
    </ng-container>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
